import MyIssueReportFields from '@/views/backstage/structure/my_issue_report_page/common/MyIssueReportFields.js'


let issue_report = {
    name: '我的問題回報',
    type: 'group',
    fields: [].concat(
        MyIssueReportFields['status'],
        MyIssueReportFields['type'], 
        MyIssueReportFields['username'],
        MyIssueReportFields['created_time'],
        MyIssueReportFields['screenshot_url'],
        MyIssueReportFields['content'],
        MyIssueReportFields['reply_content'],
    )
}

export default () => issue_report